module.exports = __webpack_public_path__ + "img/whiteBOOK.82346616.svg";